var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7999 43.8001L63.6999 43.2001C63.2999 43.0001 63.0999 42.6001 63.1999 42.2001C63.4999 40.3001 63.6999 33.7001 53.4999 30.7001C53.2999 30.6001 53.0999 30.6001 52.8999 30.6001L33.2999 30.7001C32.8999 30.7001 32.4999 30.8001 32.1999 31.0001L21.8999 37.9001C21.6999 38.0001 21.4999 38.1001 21.2999 38.1001C19.3999 38.0001 17.5999 38.2001 15.6999 38.5001C10.2999 39.6001 8.09992 42.5001 7.29992 44.0001C7.09992 44.3001 7.09992 44.7001 7.09992 45.0001C7.19992 47.4001 5.59992 50.1001 7.99992 52.3001L27.3999 52.2001L47.7999 51.7001L63.8999 51.5001C64.7999 51.4001 66.2999 50.1001 66.6999 49.3001C68.3999 46.6001 64.9999 43.9001 64.7999 43.8001Z",
    fill: "#1A1D1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 46.2002C15.1 46.2002 13.3 48.0002 13.3 50.2002C13.3 52.4002 15.1 54.2002 17.3 54.2002C19.5 54.2002 21.3 52.4002 21.3 50.2002C21.3 48.0002 19.5 46.2002 17.3 46.2002ZM57.1 46.2002C54.9 46.2002 53.1 48.0002 53.1 50.2002C53.1 52.4002 54.9 54.2002 57.1 54.2002C59.3 54.2002 61.1 52.4002 61.1 50.2002C61.1 48.0002 59.3 46.2002 57.1 46.2002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0999 39.1001V34.8001C56.0999 33.9001 55.2999 33.1001 54.3999 33.1001H33.1999C33.0999 33.1001 32.9999 33.1001 32.9999 33.2001L24.9999 38.9001C24.7999 39.0001 24.7999 39.3001 24.8999 39.5001C24.9999 39.6001 25.0999 39.7001 25.1999 39.7001C30.7999 39.7001 52.3999 39.5001 55.5999 39.6001C55.8999 39.6001 56.0999 39.4001 56.0999 39.1001C56.0999 39.2001 56.0999 39.2001 56.0999 39.1001Z",
    fill: "#3F3F3F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90005 40.2998L12.9 41.8998L10.8 44.7998L5.80005 44.8998L8.90005 40.2998Z",
    fill: "#FCEA2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9 29.2002C34.9 29.2002 34.8 27.1002 37.3 27.0002C39.7 26.9002 39.7 29.2002 39.7 29.2002",
    fill: "#92D3F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9 29.2002C34.9 29.2002 34.8 27.1002 37.3 27.0002C39.7 26.9002 39.7 29.2002 39.7 29.2002",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.1 51.2002C7.2 51.0002 6.4 50.7002 6.3 50.2002C6.2 49.2002 6 46.4002 6 45.1002C6 44.6002 6.1 44.0002 6.4 43.6002C7.5 41.6002 11.2 36.8002 21.3 37.2002L31.6 30.3002C32.1 30.0002 32.7 29.8002 33.2 29.8002L52.8 29.7002C53.1 29.7002 53.4 29.7002 53.7 29.8002C55.9 30.4002 65.4 33.8002 64.1 42.4002L65.2 43.0002C65.7 43.2002 66.1 43.7002 66.2 44.2002C66.6 45.6002 66.5 47.1002 66 48.5002M47.6 50.8002L27 51.2002L47.6 50.8002Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8999 39.7L55.0999 39.5V35",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3 55.2002C20.0615 55.2002 22.3 52.9616 22.3 50.2002C22.3 47.4388 20.0615 45.2002 17.3 45.2002C14.5386 45.2002 12.3 47.4388 12.3 50.2002C12.3 52.9616 14.5386 55.2002 17.3 55.2002Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1001 55.2002C59.8615 55.2002 62.1001 52.9616 62.1001 50.2002C62.1001 47.4388 59.8615 45.2002 57.1001 45.2002C54.3387 45.2002 52.1001 47.4388 52.1001 50.2002C52.1001 52.9616 54.3387 55.2002 57.1001 55.2002Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 42.7002L10.5 44.9002L6.80005 44.8002",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1001 43.2002H50.1001",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1001 43.2002H50.1001",
    stroke: "#61B2E4",
    strokeWidth: 2.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartPoint);
export default __webpack_public_path__ + "static/media/startPoint.a086ad04197dd871487459d144b8d62b.svg";
export { ForwardRef as ReactComponent };